"use client";

import { useLenis } from "lenis/react";
import type { ComponentProps, MouseEvent } from "react";

import {
  CAREERS_APPLICATION_SECTION_ID,
  scrollToElementId,
} from "@/lib/scroll-to-element-id";

type CareersApplicationScrollLinkProps = Omit<ComponentProps<"a">, "href">;

export function CareersApplicationScrollLink({
  onClick,
  children,
  ...rest
}: CareersApplicationScrollLinkProps) {
  const lenis = useLenis();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    scrollToElementId(CAREERS_APPLICATION_SECTION_ID, lenis);
    window.history.replaceState(null, "", `#${CAREERS_APPLICATION_SECTION_ID}`);
    onClick?.(e);
  };

  return (
    <a href={`#${CAREERS_APPLICATION_SECTION_ID}`} {...rest} onClick={handleClick}>
      {children}
    </a>
  );
}
